import { zSchema } from "@zeal/common";
import {
  baseIDUploadLinkSchema,
  TIDUploadLinkResponse,
} from "../shared/idUploadTypes";

/**
 * Request schema for generating contractor document upload links (private route)
 * Extends the shared base schema with contractor-specific fields (no testMode for private routes)
 */
export const postGenerateContractorIDUploadLinkPrivateSchema =
  baseIDUploadLinkSchema.extend({
    contractorID: zSchema.string().min(1, "Contractor ID is required"),
  });

export type TPostGenerateContractorIDUploadLinkPrivateRequest = zSchema.infer<
  typeof postGenerateContractorIDUploadLinkPrivateSchema
>;

export type TPostGenerateContractorIDUploadLinkPrivateResponse =
  TIDUploadLinkResponse;
